<template>
  <!-- 修改字典对话框 -->
  <el-dialog
    title='修改文章管理'
    :visible.sync='editDialogVisible'
    width='60%'
  >
    <el-form ref='editFormRef' :rules='rules' :model='editForm' label-width='100px'>
      <el-row>
        <!--标题-->
        <el-col :span='12'>
          <el-form-item label='标题' prop='title'>
            <el-input v-model='editForm.title' placeholder='请输入标题' />
          </el-form-item>
        </el-col>

        <!--是否顶置-->
        <el-col :span='12'>
          <el-form-item label='是否顶置' prop='top'>
            <el-select v-model='editForm.top' clearable placeholder='请选择是否顶置' style='width: 100%'>
              <el-option key='TRUE' label='是' value='TRUE'></el-option>
              <el-option key='FALSE' label='否' value='FALSE'></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <!--是否启用-->
        <el-col :span='12'>
          <el-form-item label='是否启用' prop='enumEnable'>
            <el-select v-model='editForm.enumEnable' clearable placeholder='请选择是否启用' style='width: 100%'>
              <el-option key='NORMAL' label='是' value='NORMAL'></el-option>
              <el-option key='DISABLE' label='否' value='DISABLE'></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <!--属性-->
        <el-col :span='12'>
          <el-form-item label='属性' prop='enumAttribute'>
            <el-select v-model='editForm.enumAttribute' clearable placeholder='请选择属性' style='width: 100%'>
              <el-option v-for='item in optionsAttribute' :key='item.value' :label='item.label'
                         :value='item.value'></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <!--排序-->
        <el-col :span='12'>
          <el-form-item label='排序' prop='sort'>
            <el-input v-model='editForm.sort' placeholder='请输入排序' oninput="value=value.replace(/[^\d]/g,'')" />
          </el-form-item>
        </el-col>

        <!--上传方式-->
        <!--<el-col :span="12">
          <el-form-item label="上传方式">
            <el-select v-model="choose" clearable placeholder="请选择上传方式" style="width: 100%">
              <el-option key="YES" label="文章内容" value="YES"></el-option>
              <el-option key="NO" label="跳转地址" value="NO"></el-option>
            </el-select>
          </el-form-item>
        </el-col>-->

        <!--跳转地址-->
        <el-col :span='12' v-if="choose === 'NO'">
          <el-form-item label='跳转地址' prop='link'>
            <el-input v-model='editForm.link' placeholder='请输入跳转地址' />
          </el-form-item>
        </el-col>

        <!--是否显示在首页-->
        <el-col :span='12'>
          <el-form-item label='是否显示'>
            <el-select v-model='editForm.index' clearable placeholder='请选择是否显示在首页' style='width: 100%'>
              <el-option key='YES' label='是' value='YES'></el-option>
              <el-option key='NO' label='否' value='NO'></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <!--添加标签-->
        <el-col :span='12'>
          <el-form-item label='添加标签'>
            <el-select v-model='labelIds' multiple clearable placeholder='请选择添加标签' style='width: 100%'>
              <el-option
                v-for='item in optionsLabel'
                :key='item.id'
                :label='item.name'
                :value='item.id'>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span='12'>
          <el-form-item label='更新时间'>
            <el-date-picker v-model='editForm.releaseTime' placeholder='请选择更新时间' type='date'
                            value-format='timestamp'></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='跳转到商品' prop='goodsFlag'>
            <el-switch
              disabled
              v-model="editForm.goodsFlag"
              active-text="是"
              inactive-text="否"
              :active-value="1"
              :inactive-value="0">
            </el-switch>
          </el-form-item>
        </el-col>

        <!--备注说明-->
        <el-col :span='24'>
          <el-form-item label='备注说明'>
            <el-input type='textarea' v-model='editForm.brief' placeholder='请输入备注说明' />
          </el-form-item>
        </el-col>

        <!--选择商品-->
        <el-col :span='24' v-if='editForm.goodsFlag == 1'>
          <el-form-item label='商品' prop='goodsId'>
            <el-select v-model="editForm.goodsId" placeholder="请选择商品">
              <el-option style='width: 100%;'
                         v-for="item in vipGoodsList"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <!--缩略图-->
        <el-col :span='24'>
          <el-form-item label='缩略图'>
            <thumbnail v-model='editForm.thumbnail' :autoCropWidth='800' :autoCropHeight='500'
                       :fixedNumber='[16,10]'></thumbnail>
          </el-form-item>
        </el-col>

        <!--富文本-->
        <el-col :span='24' v-if="choose === 'YES' && editForm.goodsFlag == 0">
          <!--          <Editor v-model="editForm.content" :type="'html'"></Editor>-->
          <yk-editor ref='editorRef' v-model='editForm.content'></yk-editor>
        </el-col>


      </el-row>
    </el-form>
    <div slot='footer' class='dialog-footer'>
      <el-button @click='cancel'>取 消</el-button>
      <el-button @click='modifyArticle'>确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { updateArticle } from '@/api/article/article'
import { getPostOrDeleteData } from '@/utils/code'
import Thumbnail from '@/components/common/thumbnail/thumbnails'
/*import Editor from '@/components/common/editor/editor'*/
import { getLabelList } from '@/api/label/label'
import { articleAttribute } from '@/js/enum'
import { articleRules } from '@/js/rules'
import ykEditor from '@/components/common/ckeditor/ckeditor'
import { vipGoods } from '@/api/goods/goods'

export default {
  name: 'editArticle',
  components: { Thumbnail, ykEditor },
  data() {
    return {
      editForm: {}, //修改
      optionsLabel: [],
      editDialogVisible: false,
      labelIds: [],
      optionsAttribute: articleAttribute,
      // 规则
      rules: articleRules,
      choose: '',
      vipGoodsList: []
    }
  },
  created() {
    this.getLabelList()
    this.loadGoods()
  },
  methods: {
    cancel() {
      this.editDialogVisible = false
      this.editForm = {}
    },

    //获取标签
    getLabelList() {
      const query = {
        current: 1,
        size: 10
      }
      getLabelList(query).then(res => {
        this.optionsLabel = res.code === '0' ? res.data.records : []
      })
    },

    editDialog(row) {
      this.editForm = JSON.parse(JSON.stringify(row))
      let val = this.editForm.content ? 'YES' : 'NO'
      this.choose = JSON.parse(JSON.stringify(val))
      console.log('s', this.choose)
      console.log('editForm', this.editForm)
      this.labelIds = []
      row.labelsList.forEach(f => {
        this.labelIds.push(f.id)
      })
      this.editDialogVisible = true
    },
    getHtml(html) {
      let str = html.replace('<figure', '<div')
      return str.replace('</figure>', '<div>')
    },
    loadGoods() {
      vipGoods().then(res => {
        this.vipGoodsList = res.data
      })
    },
    modifyArticle() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) return
        this.editForm.labelIds = this.labelIds.join(',')
        if (this.editForm.content) {
          this.editForm.content = this.getHtml(this.editForm.content)
        }
        if (this.editForm.goodsFlag == 1) {
          if (!this.editForm.goodsId) {
            return this.$message.error('商品不能为空')
          }

        } else {
          this.editForm.goodsId = undefined
        }
        updateArticle(this.editForm).then((response) => {
          let data = getPostOrDeleteData(response)
          if (data !== null) {
            this.$emit('refresh-list')
            this.editDialogVisible = false
          }
        })
      })
    }
  }
}
</script>

<style scoped lang='less'>
/deep/ .el-input {
  width: 90%;

}
</style>
